import { AuthCookies } from "../../utils/auth-cookies";
import { AuthAction, AuthSliceState } from "./types";

export const logoutReducer = (state: AuthSliceState): AuthSliceState => {
  state.user = null;
  AuthCookies.logout();
  
  return state;
}

export const updateAuthReducer = (state: AuthSliceState, action: AuthAction): AuthSliceState => {
  state.user = action.payload.user;
  AuthCookies.login(action.payload.token, state.user.uuid, state.user.isPremium || false);
  return state;
};
